export const TRACK_EVENT = 'TRACK_EVENT';
export const LOCATION_CHANGE = 'LOCATION_CHANGE';
export const RETRACK_ADS_IMPRESSIONS = 'RETRACK_ADS_IMPRESSIONS';

export const ENABLE_TRACKING_IMPRESSIONS = 'ENABLE_TRACKING_IMPRESSIONS';
export const DISABLE_TRACKING_IMPRESSIONS = 'DISABLE_TRACKING_IMPRESSIONS';

export const MIN_ORGANIC_ADS_COUNT_TO_SHOW_SIMILAR_CONTENT_ADS = 15;



// WEBPACK FOOTER //
// ./app/tracking/constants.js